import { DateInput } from "@mantine/dates";
import { useRef, useState } from "react";
import classes from "styles/CalculatorStyles/BMICalculator.module.css";
import CalculationCalendarIcon from "./CalculationCalendarIcon";
import {
  calculationFormatDateInput,
  calculationParseAndValidateDate,
  calculationParseDateInputNew,
} from "./helper";

interface DatePickerCalculatorProps<T = Record<string, any>> {
  onChange: (fieldName?: string, value?: Date | null) => void;
  value: any;
  error: any;
  name?: string;
  label?: string;
  maxDate?: Date;
  defaultViewDate?: Date;
}

const DatePickerCalculator = <T extends Record<string, any>>({
  value,
  error,
  onChange,
  name = "date",
  label = "",
  maxDate = new Date(),
  defaultViewDate,
}: DatePickerCalculatorProps<T>) => {
  const dateInputRefs = useRef<Record<string, HTMLInputElement | null>>({});
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const cursorPositionRef = useRef(0);

  const openCalendar = (fieldKey: string) => {
    const input = dateInputRefs.current[fieldKey];
    if (!input) return;

    isCalendarOpen ? input.blur() : input.focus();
    setIsCalendarOpen(!isCalendarOpen);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target;
    const raw = input?.value || "";
    const start = input.selectionStart || 0;

    // Save cursor position before formatting
    cursorPositionRef.current = start;

    const formatted = calculationFormatDateInput(raw, start);
    input.value = formatted;

    // Update cursor position after formatting
    const newCursorPos =
      cursorPositionRef.current + (formatted.length - raw.length);
    input.setSelectionRange(newCursorPos, newCursorPos);

    // Parse and validate
    if (formatted.length === 10) {
      const parsed = calculationParseAndValidateDate(formatted);

      console.log(parsed, "parsed")

      // check for future dates when typing
      if (parsed && parsed > new Date()) {
        onChange(name, null);
        return;
      }

      onChange(name, parsed);
    } else {
      onChange(name, null);
    }
  };

  const handleCalendarChange = (date: Date | null) => {
    if ((date && date > new Date()) || !date) {
      console.log("future Date");
      return;
    }
    onChange(name, date);
  };

  const initialCalendarViewDate = value || defaultViewDate || undefined;

  return (
    <DateInput
      label={label}
      ref={(ref) => {
        dateInputRefs.current[name] = ref;
      }}
      date={initialCalendarViewDate}
      value={value}
      onChange={handleCalendarChange}
      rightSection={
        <CalculationCalendarIcon onClick={() => openCalendar(name)} />
      }
      dateParser={calculationParseDateInputNew}
      placeholder="dd/mm/yyyy"
      size="sm"
      radius="md"
      withAsterisk
      classNames={classes}
      maxDate={maxDate}
      hideOutsideDates
      error={error}
      onFocus={() => setIsCalendarOpen(true)}
      onInput={handleInputChange}
      valueFormat="DD/MM/YYYY"
    />
  );
};

export default DatePickerCalculator;
